"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaseCard = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Tag = require("../Tag");
var _Text = require("../Text");
var _Title = require("../Title");
var _Image = require("../Image");
var _ButtonGroup = require("../ButtonGroup");
var _context = require("../ConfigProvider/context");
var _useTracking2 = require("../../hooks/useTracking");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var PREFIX = (0, _getPrefixCls.getPrefixCls)('case');
var CaseCard = function CaseCard(_ref) {
  var _buttonGroup$buttons;
  var title = _ref.title,
    desc = _ref.desc,
    image = _ref.image,
    statusText = _ref.statusText,
    statusColor = _ref.statusColor,
    date = _ref.date,
    buttonGroup = _ref.buttons,
    onCardClick = _ref.onCardClick,
    cardAction = _ref.cardAction,
    trackingData = _ref.trackingData;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var _useTracking = (0, _useTracking2.useTracking)({
      trackingData: trackingData
    }),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var handleCardClick = function handleCardClick() {
    var _context$eventEmitter, _context$eventEmitter2;

    // 点击埋点
    trackingClick && tracker.click(trackingClick);
    onCardClick === null || onCardClick === void 0 ? void 0 : onCardClick();
    cardAction && (context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, cardAction === null || cardAction === void 0 ? void 0 : cardAction.func, {
      text: '',
      action: cardAction
    }, cardAction.callback));
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: PREFIX
  }, trackingImpressionProps), /*#__PURE__*/_react.default.createElement("div", {
    onClick: handleCardClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-info")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-info-content")
  }, /*#__PURE__*/_react.default.createElement(_Title.Title, {
    className: "".concat(PREFIX, "-info-title"),
    content: title,
    maxLines: 1
  }), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    className: "".concat(PREFIX, "-info-desc"),
    content: desc,
    maxLines: 2
  })), image && /*#__PURE__*/_react.default.createElement(_Image.Image, {
    className: "".concat(PREFIX, "-info-image"),
    src: image
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-status")
  }, /*#__PURE__*/_react.default.createElement(_Tag.Tag, {
    className: "".concat(PREFIX, "-status-text"),
    color: statusColor
  }, statusText), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    className: "".concat(PREFIX, "-status-date"),
    content: date,
    maxLines: 1
  }))), buttonGroup !== null && buttonGroup !== void 0 && (_buttonGroup$buttons = buttonGroup.buttons) !== null && _buttonGroup$buttons !== void 0 && _buttonGroup$buttons.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-divider")
  }) : null, buttonGroup && /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, buttonGroup));
};
exports.CaseCard = CaseCard;